import IMask from 'imask'

export default class Forms {
  constructor() {
    this.cellphone = document.querySelector('[name="cellphone"]')
    this.phone = document.querySelector('[name="phone"]')

    this.ready()
  }

  static serializeJSON(form) {
    const formData = new FormData(form)

    const pairs = {}

    for (const [name, value] of formData) {
      pairs[name] = value
    }

    return JSON.stringify(pairs, null, 2)
  }

  static wrongMessages() {
    const mensagens = {
      messages: {
        missingValue: {
          checkbox: 'Este campo é obrigatório.',
          radio: 'Por favor, selecione um valor.',
          select: 'Por favor, selecione um valor.',
          'select-multiple': 'Por favor selecione pelo menos um valor.',
          default: 'Por favor, preencha este campo',
        },
        patternMismatch: {
          email: 'Insira um endereço de e-mail válido.',
          url: 'Informe uma url.',
          number: 'Informe o telefon e',
          date: 'Por favor, utilizar o formato DD/MM/YYYY',
          default: 'Please match the requested format.',
        },
        outOfRange: {
          over: 'Selecione um valor que não seja superior a {max}.',
          under: 'Selecione um valor que não seja inferior a {min}.',
        },
        wrongLength: {
          over: 'Reduza este texto para não mais do que {maxLength} caracteres. Atualmente você está usando {length} caracteres.',
          under:
            'Aumente este texto para {minLength} caracteres ou mais. Atualmente você está usando {length} caracteres.',
        },
      },
    }
    return mensagens
  }

  ready() {
    if (this.cellphone) {
      IMask(this.cellphone, {
        mask: '(00) 00000-0000',
      })
    }

    if (this.phone) {
      IMask(this.phone, {
        mask: '(00) 0000-0000',
      })
    }
  }
}
